import { useEffect, useState } from 'react'
import cn from 'classnames'
import { useAppDispatch, useAppSelector } from 'redux/hooks'
import { makeSelectGarage } from 'redux/features/bienAVendre/selectors'
import {
  initGarage,
  initGarageSpace,
  resetGarage,
  initGaragePosition,
  setCalculViaConfigurateurAvance,
} from 'redux/features/bienAVendre/slice'
import s from 'pages/common.module.scss'
import InputNumber from 'components/InputNumber'
import Label from 'components/Label'
import { getTooltip, Tooltip } from '../../../../../../utils/tooltipLibrary'

export enum TypeGarage {
  Aucun = 0,
  SousSol = 1,
  Attenant = 2,
}

const GarageCalculator = () => {
  const [activeTypeDeGarage, setActiveTypeDeGarage] = useState(TypeGarage.Aucun)
  const [garageSurface, setGarageSurface] = useState(0)
  const garage = useAppSelector(makeSelectGarage)
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setCalculViaConfigurateurAvance(true))
  }, [garageSurface, dispatch])

  const handleTypeDeGarage = (type: TypeGarage) => {
    setActiveTypeDeGarage(type)
    switch (type) {
      case TypeGarage.SousSol:
        dispatch(initGarage(1))
        dispatch(initGaragePosition(1))
        break
      case TypeGarage.Attenant:
        dispatch(initGarage(1))
        dispatch(initGaragePosition(2))
        break
      case TypeGarage.Aucun:
      default:
        dispatch(resetGarage())
        dispatch(setCalculViaConfigurateurAvance(true))
        break
    }
    setGarageSurface(0)
  }

  const handleSurfaceGarage = (value: number) => {
    dispatch(initGarageSpace(value))
    setGarageSurface(value)
  }

  return (
    <>
      <div className={s.garageV2}>
        <Label
          label="Garage : "
          classes={s.tooltipSublevel}
          tooltip={getTooltip(Tooltip.Garage)}
        />
        <div>
          <button
            type="button"
            className={cn(
              s.buttonToggle,
              activeTypeDeGarage === TypeGarage.Aucun ? s.active : ''
            )}
            onClick={() => handleTypeDeGarage(TypeGarage.Aucun)}
            onKeyPress={() => handleTypeDeGarage(TypeGarage.Aucun)}
            tabIndex={0}
          >
            Aucun
          </button>
          <button
            type="button"
            className={cn(
              s.buttonToggle,
              activeTypeDeGarage === TypeGarage.SousSol ? s.active : ''
            )}
            onClick={() => handleTypeDeGarage(TypeGarage.SousSol)}
            onKeyPress={() => handleTypeDeGarage(TypeGarage.SousSol)}
            tabIndex={0}
          >
            Sous-sol
          </button>
          <button
            type="button"
            className={cn(
              s.buttonToggle,
              activeTypeDeGarage === TypeGarage.Attenant ? s.active : ''
            )}
            onClick={() => handleTypeDeGarage(TypeGarage.Attenant)}
            onKeyPress={() => handleTypeDeGarage(TypeGarage.Attenant)}
            tabIndex={0}
          >
            Attenant
          </button>
        </div>
      </div>
      {garage === 1 && (
        <div className={s.garageSurface}>
          <Label label="Surface du garage : " classes={s.tooltipSublevel} />
          <div className={s.inputSurface}>
            <InputNumber
              onChange={(value) => {
                if (!Number.isNaN(value)) {
                  handleSurfaceGarage(value)
                } else {
                  setGarageSurface(0)
                }
              }}
              value={garageSurface}
            />

            <span>m²</span>
          </div>
        </div>
      )}
    </>
  )
}

export default GarageCalculator
